import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[appInsertion]',
    standalone: true
})
export class InsertionDirective {
  viewContainerRef = inject(ViewContainerRef);

}
